// Login Page
export const APP_INIT = "APP_INIT";

// Login Page
export const HTTP_LOGIN_FETCHING = "HTTP_LOGIN_FETCHING";
export const HTTP_LOGIN_SUCCESS = "HTTP_LOGIN_SUCCESS";
export const HTTP_LOGIN_FAILED = "HTTP_LOGIN_FAILED";

// Error Code
export const E_PICKER_CANCELLED = "E_PICKER_CANCELLED";
export const E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR =
  "E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR";
export const E_PERMISSION_MISSING = "E_PERMISSION_MISSING";
export const E_PICKER_NO_CAMERA_PERMISSION = "E_PICKER_NO_CAMERA_PERMISSION";
export const E_USER_CANCELLED = "E_USER_CANCELLED";
export const E_UNKNOWN = "E_UNKNOWN";
export const E_DEVELOPER_ERROR = "E_DEVELOPER_ERROR";
export const TIMEOUT_NETWORK = "ECONNABORTED"; // request service timeout
export const NOT_CONNECT_NETWORK = "NOT_CONNECT_NETWORK";

//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE =
  "Cannot connect to server, Please try again.";
export const NETWORK_TIMEOUT_MESSAGE =
  "A network timeout has occurred, Please try again.";
export const UPLOAD_PHOTO_FAIL_MESSAGE =
  "An error has occurred. The photo was unable to upload.";

export const apiUrl = process.env.REACT_APP_BASEURL + "/api/v1.0";
export const apiUrl_image = process.env.REACT_APP_BASEURL;
export const url_web = process.env.REACT_APP_WEBURL;

export const key_wijmo = "komatsu.feyverly.com|komatsu.uat.fysvc.com|komatsu.dev.fysvc.com,532241386435754#B0AzHJNWb8BTeO56N8gnNEVWRwhHV52Wd8cmMNl7Z7R4aYZ4YwNUbBxkQ0l6dOZEVuZFU0hHMxdVdEdGe9pFcnpHVXVlS5EXc7k5b4pVV55kayh4VCJVNxNldFNXT4syR73kaGZ5cDNEOsV5b8ZHV5VHWHtUYJdmazRnSFNzYVdzbC9WUxgke7V5T4MEStVzYrQ5QTN6R4skWs3yLENlNuF5YqF7YQJ6YOhmNhtEVyckWDJFdQhTR8EWWZNTShJ6Q7BnS5YzbkZkWtxWV6ZHSSVDex3yK9QUUPJTZ5RGTwxGTGhjcnljb5QFdDZkaiB7Z6k7KOl6UGBVOX3UY5gnUxdHUJl4aLVFbmVEaslzdQ34LDJiOiMlIsICMyI4Q4EUN4IiOigkIsATM6AzM7QzM0IicfJye&Qf35VfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1tlOiQmcQJCLiITNyQDNwAiNxYDMxIDMyIiOiQncDJCLi46bj9yY6NXem9idlRmL5NHdh56brxSbvNmLjZ7c9ZmL4FWduU7c4FWbvtGLt36YukHbyVmd9VmZuU7c4FWbvtmI0IyctRkIsIiLkRHTgwiLvNEI9xmclZXelZkI0ISYONkIsICN5cTNzQjN8MTM4IjMzUjI0ICZJJCL355W0IyZsZmIsIiM6FjMwIjI0IiclZnIsU6csFmZ0IiczRmI1pjIs9WQisnOiQkIsISP3EkSXBTQW9mMQlXamhXW9hWOxVHOUBHblR4TMFlRVBTdvkEUTBHRX5GRrEjWWlDeEBlQ8IGV7dHdvkTVTVTUNVTdvuE8v";

export const YES = "YES";
export const NO = "NO";
export const OK = "ok";
export const NOK = "nok";

export const COLOR_PRIMARY = '#FFCC00';
export const COLOR_SECONDARY = '#D40511';

export const server = {
  LOGIN_URL: `/login`,
  REGISTER_URL: `/register`,
  LOGIN_PASSED: `yes`,
};
